var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 22H3C2.59 22 2.25 21.66 2.25 21.25C2.25 20.84 2.59 20.5 3 20.5H21C21.41 20.5 21.75 20.84 21.75 21.25C21.75 21.66 21.41 22 21 22Z",
    fill: "url(#paint0_linear_269_738)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0201 3.48016C17.0801 1.54016 15.1801 1.49016 13.1901 3.48016L11.9801 4.69016C11.8801 4.79016 11.8401 4.95016 11.8801 5.09016C12.6401 7.74016 14.7601 9.86016 17.4101 10.6202C17.4501 10.6302 17.4901 10.6402 17.5301 10.6402C17.6401 10.6402 17.7401 10.6002 17.8201 10.5202L19.0201 9.31016C20.0101 8.33016 20.4901 7.38016 20.4901 6.42016C20.5001 5.43016 20.0201 4.47016 19.0201 3.48016Z",
    fill: "url(#paint1_linear_269_738)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6101 11.5298C15.3201 11.3898 15.0401 11.2498 14.7701 11.0898C14.5501 10.9598 14.3401 10.8198 14.1301 10.6698C13.9601 10.5598 13.7601 10.3998 13.5701 10.2398C13.5501 10.2298 13.4801 10.1698 13.4001 10.0898C13.0701 9.8098 12.7001 9.4498 12.3701 9.0498C12.3401 9.0298 12.2901 8.9598 12.2201 8.8698C12.1201 8.7498 11.9501 8.5498 11.8001 8.3198C11.6801 8.1698 11.5401 7.9498 11.4101 7.7298C11.2501 7.4598 11.1101 7.1898 10.9701 6.9098C10.9489 6.86441 10.9284 6.81924 10.9085 6.77434C10.7609 6.44102 10.3263 6.34358 10.0685 6.60133L4.34007 12.3298C4.21007 12.4598 4.09007 12.7098 4.06007 12.8798L3.52007 16.7098C3.42007 17.3898 3.61007 18.0298 4.03007 18.4598C4.39007 18.8098 4.89007 18.9998 5.43007 18.9998C5.55007 18.9998 5.67007 18.9898 5.79007 18.9698L9.63007 18.4298C9.81007 18.3998 10.0601 18.2798 10.1801 18.1498L15.9014 12.4285C16.1609 12.1689 16.063 11.7235 15.7254 11.5794C15.6874 11.5632 15.649 11.5467 15.6101 11.5298Z",
    fill: "url(#paint2_linear_269_738)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_269_738",
    x1: 0.108381,
    y1: 21.2457,
    x2: 7.35606,
    y2: 31.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF6AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_269_738",
    x1: 10.9174,
    y1: 6.2983,
    x2: 20.4904,
    y2: 7.34434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF6AE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_269_738",
    x1: 2.06987,
    y1: 12.4874,
    x2: 16.4596,
    y2: 14.0632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#164EB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF6AE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.9b896106868471e974fabcbc4bcdc562.svg";
export { ForwardRef as ReactComponent };